import { useTheme } from '@emotion/react'
import { Container, Grid } from '@mui/material'
import React, { useState } from 'react'
import { P, SectionSmallHeading, SectionSubHeading, SectionWrapper } from '../../Styles/style'
import Draco from "../../../assets/images/Draco.png"
import Zelda from "../../../assets/images/Zelda.png"
import inu from "../../../assets/images/inu.png"
import powell from "../../../assets/images/clinton.png"
import carlos from "../../../assets/images/carlos.png"
import up from "../../../assets/images/fourthbg.png"
import styled from '@emotion/styled'
const LogoImg = styled.img`
    width:100%;
    height:auto;
    max-width:231px;
`
const Dracoimg = styled.img`
    width:100%;
    height:auto;
    max-width:255px;
`
const BuyNow = styled.a`
text-decoration: none;

`
const Div = styled.div`
  background-image: url(${up});
  background-size: cover;
  background-position: center center;
`;

const Section9_Footer = () => {

    const theme = useTheme()
    return (
        <>
        <Div>
            <SectionWrapper p="3.5rem 0" id="contact"  align="center">
                <Container maxWidth="xl">
                    <SectionSubHeading p="0px 0 20px">Team</SectionSubHeading>
                    <Grid container justifyContent="center" spacing={5} >
                        <Grid item xs={12} md={2}/> 
                        <Grid item xs={12} md={2} >
                            <Dracoimg src={Draco}/>
                            <SectionSmallHeading align="center">@severussnape</SectionSmallHeading>
                        </Grid>
                        <Grid item xs={12} md={2} >
                            <Dracoimg src={Zelda}/>
                            <SectionSmallHeading align="center">@Zelda</SectionSmallHeading>
                        </Grid>
                        <Grid item xs={12} md={2} >
                            <Dracoimg src={inu}/>
                            <SectionSmallHeading align="center">@Inu</SectionSmallHeading>
                        </Grid>
                        <Grid item xs={12} md={2} />
                       
                    </Grid>
                    <br/>
                    <Grid container justifyContent="center" spacing={5} >
                        <Grid item xs={12} md={2}/> 
                        <Grid item xs={12} md={2} >
                            <Dracoimg src={powell}/>
                            <SectionSmallHeading align="center">@Clinton</SectionSmallHeading>
                        </Grid>
                        <Grid item xs={12} md={2} >
                            <Dracoimg src={carlos}/>
                            <SectionSmallHeading align="center">@Carlos</SectionSmallHeading>
                        </Grid>
                        <Grid item xs={12} md={2} />
                       
                    </Grid>
                </Container>
            </SectionWrapper>
            </Div>
            <SectionWrapper bgColor="#fff">
                <SectionSmallHeading fs="17px" color="#000"  p="20px 0" m="0" align="center" data-aos="flip-up"
                    data-aos-easing="ease-in"
                    data-aos-delay="400"
                    data-aos-duration="400"
                    data-aos-offset="0"> © 2023 by SeverusSnapeClintonCarlosLink1000XInu. All rights reserved!
                </SectionSmallHeading>
            </SectionWrapper>

        </>
    )
}

export default Section9_Footer